import { Injectable } from '@angular/core';
import {AppServices} from '../../services';
import {CommonServices} from '../../services/src/api';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';
import {EnvUtils} from '../../utils';

@Injectable()
export class AuthServices {
    userRole: any = {
        userId: '',
        userNm: '',
        cmpnId: '',
        roleCd: [],
        rolePrms: []
    };
    accessToken: string;

    constructor(private _appServices: AppServices,
                private commonServices: CommonServices) {
        this.userRole = global['userRole'];
    }

    /* 서브 메뉴 권한 인증 */
    isMenuAuthenticate(rsrcPathVal) {
        const rolePrms = global['userRole'].rolePrms;

        const permission = rolePrms.some((perm: {rsrcPathVal: string}) => {
            if (_.startsWith(perm.rsrcPathVal, rsrcPathVal)) {
                return true;
            }
        });

        return permission;
    }

    /* 버튼 권한 인증 */
    isAuthenticate(rsrcPathVal, actnId) {
        const rolePrms = global['userRole'].rolePrms;

        let rolePrm = _.find(rolePrms, {'rsrcTypeCd': 'PRMS_RSRC_010', 'rsrcPathVal': rsrcPathVal, 'actnId': '*'});

        if (rolePrm === undefined && actnId === 'r') {
            rolePrm = _.find(rolePrms, {'rsrcTypeCd': 'PRMS_RSRC_010', 'rsrcPathVal': rsrcPathVal, 'actnId': actnId});
        }

        return rolePrm === undefined ? false : true;
    }

    isLcnsAuthenticate(lcnsCd) {
        const trgtCd = Number(lcnsCd.replace('LCNS', ''));
        const currLcnsTypeCd = global['userRole'].currLcnsTypeCd;
        const cd = Number(currLcnsTypeCd.replace('LCNS', ''));

        if (cd >= trgtCd) {
            return true;
        } else {
            return false;
        }
    }

    /* URL 권한 인증
    * Todo observable로 개선필요
    * 현재는 호출 하지않음*/
    isUrlAuthenticated(rsrcPathVal): Observable<boolean> {
        // 크롬은 세션 조회 후 가드 작동, IE/엣지는 가드 작동 후 세션 조회 : userRole 이 undefined 가 됨!!!
        let userRole = global['userRole'];

        if (userRole === undefined) {
            return this.commonServices.getSessionMap(EnvUtils.envCdToAccessToken())
                .map(rsltUserRole => {
                    userRole = rsltUserRole;

                    const rolePrm = _.find(userRole.rolePrms, {'rsrcTypeCd': 'PRMS_RSRC_020', 'rsrcPathVal': rsrcPathVal});
                    console.log('재확인 결과', rolePrm === undefined ? false : true);
                    return rolePrm === undefined ? false : true;
                });

            // 다시 세션 조회
            //this._appServices.getSession();
        } else {
            const rolePrm = _.find(userRole.rolePrms, {'rsrcTypeCd': 'PRMS_RSRC_020', 'rsrcPathVal': rsrcPathVal});
            return Observable.of(rolePrm === undefined ? false : true);
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/authentications/src/auth.services.ts